/**
 * 🧵 **The loom's three slots — D136.** Warp · weft · cloth.
 *
 * ⚠️ **A file of its own, with no imports, on purpose**: `chest.ts` needs these
 * for the loom's container rules, and `loom.ts` imports `bur.ts`, which imports
 * `chest.ts` — so the rules cannot live in `loom.ts` without a circle.
 * `loom.ts` re-exports everything here.
 */

/** 🧵 What goes on the loom, as warp and as weft. */
export const LOOM_THREAD = 'thradur';
/** 🧶 What comes off it — one per ELL. */
export const LOOM_CLOTH = 'vadmal';

/** The three slots, left to right: the warp's thread, the weft's thread, the cloth. */
export const WARP_SLOT = 0;
export const WEFT_SLOT = 1;
export const CLOTH_SLOT = 2;

/** 🧵 May this item go into this slot of a loom? Thread in the first two, cloth in the third. */
export function loomSlotAccepts(slot: number, itemKey: string): boolean {
  if (slot === WARP_SLOT || slot === WEFT_SLOT) return itemKey === LOOM_THREAD;
  if (slot === CLOTH_SLOT) return itemKey === LOOM_CLOTH;
  return false;
}
